package core.localStorage

import kotlinx.serialization.SerialName

@kotlinx.serialization.Serializable
data class SettingsObject(
    @SerialName("piwikTrackingNativeActive")
    var mPiwikTrackingNativeActive: Boolean
)
